<template>
    <div class="content">
    <div class="container-fluid">
      <div class="row">
        <div class="col-12 col-xl-6">
              <h2 class="card-title">Plan de Prévention Evolutif</h2>
        </div>
      </div>

      <div class="row">
        <div class="col-md-6">
            <card class="bg-light login-bloc">
              <template slot="header">
                <h4 class="card-title">Inscrivez-vous</h4>
                <p class="card-category">Si vous n'avez pas encore de compte sur PPE</p>
              </template>
              <p class="card-category">Renseignez les informations de votre entreprise</p>
              <p></p>
              <router-link class="card-link" :to="urlWithRedirect('/register')">Créer un compte</router-link>
            </card>
        </div>

        <form class="col-md-6" validated @submit="onSubmit" >
            <card class="bg-light login-bloc">
              <template slot="header">
                <h4 class="card-title">Identifiez-vous</h4>
                <p class="card-category">Vous avez déjà un compte sur PPE</p>
              </template>

              <b-form-group
                label="Votre email de connexion"
                label-for="login"
                description="L'email qui vous a servi lors de votre inscription sur PPE"
                class=""
                aria-errormessage="please enter"
              >
                <b-form-input
                  id="login"
                  type="email"
                  v-model="form.login"
                  placeholder="Votre email de connexion"
                  required
                ></b-form-input>
              </b-form-group>

              <b-form-group
                label="Mot de passe"
                label-for="password"
                class=""
              >
                <b-form-input
                  id="password"
                  type="password"
                  v-model="form.password"
                  placeholder="Mot de passe"
                  required
                ></b-form-input>
              </b-form-group>
              <router-link to="/reset">Mot de passe oublié ?</router-link> 

              <b-form-group class="float-right">
                <b-button type="submit" variant="primary">Valider</b-button>
              </b-form-group>
            </card>
        </form>
      </div>
    </div>
    </div>    
</template>
<style scoped>
.login-bloc {
  height: 250pt;
}
</style>
<script>
import Card from "../components/Cards/Card.vue";
import swal from "sweetalert";
import common from './common/pages.js'

export default {
  components: {
    Card,
  },
  data() {
    return  {
      form: {
        login : this.$route.params.email,
        password : ''
      }
    }
  },
    methods: {
      ...common.methods,
      async onSubmit(event) {
        event.preventDefault()
        // console.log("JSON.stringify(this.form)",JSON.stringify(this.form))

        try {
          //console.log("BEFORE LOGIN", this.form)
          let response = await this.$http.post("/user/login", this.form );
          //console.log("RESPONSE", token)
          let token = response.data.token;

          if(this.$usermanager.logUserIn(token)) {
            //console.log("window.location", window.location.search)
            //swal("Login", "Identification réussie", "success");
            // TODO: if url has redirect, then redirect to argument
            
            let user = response.data.user
            if(user.isTempPassword) {
              return this.$router.push("/changepassword/"+user.id)
            }

            if(this.$route.query.redirectUrl)
              this.$router.push(this.$route.query.redirectUrl)
            else if( this.$usermanager.isAdmin() )
              this.$router.push("/admin")
            else if( this.$usermanager.isHost()) 
              this.$router.push("/ppe_eu")
            else  
              this.$router.push("/ppe_ee")
              
          }
        } catch (err) {
          console.log(JSON.stringify(err, null, 2))
          swal("Erreur", err.response? (err.response.data.error) : JSON.stringify(err), "error");
          console.log(err.response.data.error);
        }
      },
    }
}
</script>
